import { XMarkIcon } from "@heroicons/react/24/solid";
import NavItem from './NavItem'

const SlideOver = ({ isOpen, onClose }) => {
    const handleClick = () => {
      window.open("https://www.hootboard.com/nrccs", "_blank");
    };

    const goToMembership = () => {
      window.location = "/membership";
    }
    return (
      <div className={`fixed inset-0 overflow-hidden ${isOpen ? 'z-50' : 'hidden'}`}>
        {/* Background backdrop */}
        <div
          className={`fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity ${isOpen ? 'opacity-100 ease-in-out duration-1000' : 'opacity-0'}`}
          aria-hidden="true"
          onClick={onClose}
        ></div>
        
        {/* Slide-over panel */}
        <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex">
          <div
            className={`relative w-screen max-w-md bg-white shadow-xl transform transition ease-in-out duration-1000 sm:duration-1000 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
          >
            {/* Content */}
            <div className="p-6 flex flex-col justify-between h-full">{/* Your slide-over content goes here */}

              <div>
                <div className="flex justify-end items-center">
                  <button onClick={onClose} className="border rounded-lg hover:bg-slate-200 shadow-sm">
                    <XMarkIcon className="w-8 h-8" />
                  </button>
                </div>

                <div className="grid grid-rows gap-6">
                  <NavItem dir="/" dirName={"Home"} callFunct={onClose} />
                  <NavItem dir="/about_us" dirName={"About us"} callFunct={onClose} />
                  <NavItem dir="/mounthly_meeting" dirName={"Monthly meetings"} callFunct={onClose} />
                  <NavItem dir="/scholarship" dirName={"Scholarship"} callFunct={onClose} />
                  <NavItem dir="/anual_honoring" dirName={"Annual Honoring"} callFunct={onClose} />
                  <NavItem dir="/contact_us" dirName={"Contact us"} callFunct={onClose} />
                </div>
              </div>


              <div className="flex flex-col gap-4">
                <button onClick={handleClick} className="font-malaya text-md bg-[#1E2332] w-full py-5 group relative hover:border-none tracking-widest text-xs font-bold">
                    
                    <div class="absolute inset-0 w-0 bg-slate-50 transition-all duration-300 ease-out group-hover:w-full"></div>
                    <span className="relative text-slate-50 group-hover:text-[#1E2332] uppercase">
                        Bulletin Board
                    </span>
                    
                </button>

                <button onClick={goToMembership} className="font-malaya text-md bg-[#E2B937] w-full py-5 group relative hover:border-none tracking-widest text-xs font-bold">
                    
                    <div class="absolute inset-0 w-0 bg-slate-50 transition-all duration-300 ease-out group-hover:w-full"></div>
                    <span className="relative text-slate-50 group-hover:text-[#1E2332] uppercase">
                        Membership
                    </span>
                    
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default SlideOver;
  